import { get } from 'lib/sequence/component/state/value'

/**
 * Returns the maximum date value according to the selected option.
 *
 * @param {string} value        the selected option's value
 * @returns {{maxDate: string}} an object containing the minimum date
 */
const toDateString = (value) => {
  const date = new Date()

  switch (value) {
    case '1m':
      date.setMonth(date.getMonth() - 1)
      break
    case '2w':
      date.setDate(date.getDate() - 14)
      break
    case '3m':
      date.setMonth(date.getMonth() - 3)
      break
    case '1y':
      date.setFullYear(date.getFullYear() - 1)
      break
    default:
    // current timestamp
  }
  return { maxDate: date.toISOString() }
}

/**
 * Sets the date created filter according to the selected value.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @returns {function(*, {filter?: {}}=, ...[*]): Promise<[undefined,{filter: {}},...*[]]>}
 */
export default module => async (children, { filter = {} } = {}, ...args) => {
  const { notModifiedSince } = children

  const accumulatedFilter = filter
  const modified = get(notModifiedSince)
  modified && modified !== '0' && (accumulatedFilter.modify_timestamp = toDateString(modified))

  return [children, { filter: accumulatedFilter }, ...args]
}
